import React from 'react';
import { ACTIVE_BRAND } from '../branding';
import './ReadyToStartPage.css';

function ReadyToStartPage({ service, onStart, onCancel }) {
  const serviceNames = {
    'membership-onboarding': 'Membership Onboarding',
    'membership-management': 'Membership Management',
    'gsl': 'GSL',
    'wymac': 'WYMAC'
  };

  return (
    <div className="ready-page">
      <div className="ready-content">
        <div className="ready-card">
          <h1 className="ready-title" style={{ color: ACTIVE_BRAND.colors.primary }}>
            {serviceNames[service] || 'ID Verification'}
          </h1>
          
          <p className="ready-message">
            Please ensure you have your ID ready to scan.
          </p>
          
          <p className="ready-instructions">
            When you press Start, you will be prompted to place your ID on the scanner.
          </p>

          <div className="button-group">
            <button 
              className="start-button"
              onClick={onStart}
              style={{
                backgroundColor: ACTIVE_BRAND.colors.buttonBg,
                color: ACTIVE_BRAND.colors.buttonText
              }}
            >
              START SCAN
            </button>
            <button 
              className="cancel-button"
              onClick={onCancel}
              style={{
                borderColor: ACTIVE_BRAND.colors.buttonBg,
                color: ACTIVE_BRAND.colors.buttonBg
              }}
            >
              CANCEL
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReadyToStartPage;
